'use client';

import { Box } from '@mui/material';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { BarChart } from 'echarts/charts';
import { GridComponent, TooltipComponent } from 'echarts/components';
import * as echarts from 'echarts/core';
import { SVGRenderer } from 'echarts/renderers';
import { type FC, useMemo } from 'react';

type Props = {
  D: number;
  I: number;
  S: number;
  C: number;
  isBlury?: boolean;
};

// Register the required components
echarts.use([TooltipComponent, GridComponent, BarChart, SVGRenderer]);

const colors = ['#FF3333', '#FCB91B', '#15CB31', '#2490D9'];

export const AuraDiscGraph: FC<Props> = (props: Props) => {
  const { D, I, S, C, isBlury = false } = props;
  const blurFilter = isBlury ? 'blur(4px)' : 'blur(0)';

  const data = useMemo(
    () => [
      {
        name: 'D',
        value: isBlury ? Math.floor(Math.random() * 101) : D,
      },
      {
        name: 'I',
        value: isBlury ? Math.floor(Math.random() * 101) : I,
      },
      {
        name: 'S',
        value: isBlury ? Math.floor(Math.random() * 101) : S,
      },
      {
        name: 'C',
        value: isBlury ? Math.floor(Math.random() * 101) : C,
      },
    ],
    [isBlury, D, I, S, C]
  );

  const option = useMemo(
    () => ({
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        valueFormatter: (value: string) => `${value}%`,
      },
      grid: {
        left: 0,
        right: 0,
        top: '16px',
        bottom: 0,
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: data.map((item) => item.name),
        axisLabel: {
          show: true,
          fontWeight: 'bolder',
        },
      },
      yAxis: {
        type: 'value',
        min: 0,
        max: 100,
        interval: 10,
        axisLabel: {
          formatter: (value: string, index: number) => {
            return index === 0 ||
              index === 3 ||
              index === 5 ||
              index === 7 ||
              index === 10
              ? `${value}%`
              : null;
          },
        },
      },
      series: [
        {
          type: 'bar',
          data: data.map((item) => item.value),
          label: {
            show: true,
            position: 'top',
            fontWeight: 'bolder',
            formatter: '{c}%',
          },
          itemStyle: {
            color: (params: any) => {
              return colors[params['dataIndex']];
            },
          },
        },
      ],
    }),
    [data]
  );

  return (
    <Box
      component="div"
      width={{ none: '280px', sx: '340px' }}
      height={{ none: '350px', sx: '480px' }}
      sx={{ filter: blurFilter }}
    >
      <ReactEChartsCore
        echarts={echarts}
        option={option}
        notMerge={true}
        lazyUpdate={true}
        theme={'theme_name'}
        style={{ height: '100%', width: '100%' }}
        opts={{}}
      />
    </Box>
  );
};
